import React from "react";
import PropTypes from "prop-types";

import {
  CommentInfoText,
  CommentTitleText,
  CommentTitleValue,
} from "./Comments.styled";

const CommentData = (props) => {
  const { title, text } = props;

  return (
    <CommentInfoText>
      <CommentTitleText>{`${title} :`} </CommentTitleText>
      <CommentTitleValue>{`${text}`}</CommentTitleValue>
    </CommentInfoText>
  );
};

CommentData.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default CommentData;
